import { Routes } from '@angular/router';
import { adminRoutes } from './sub-routes/admin-route';
import { ownerRoutes } from './sub-routes/owner-routes';

export const routes: Routes = [
	{
		path: '',
		redirectTo: 'welcome',
		pathMatch: 'full'
	},
	{
		path: 'welcome',
		loadComponent: () => import('../pages/auth/splash-screen/splash-screen').then(m => m.SplashScreen),
		data: {
			isHeader: 0,
			isFooter: 0,
			isSidebar: 0,
			isNavbar: 0
		}
	},
	{
		path: 'auth/login',
		loadComponent: () => import('../pages/auth/login/login').then(m => m.Login),
		data: {
			isHeader: 0,
			isFooter: 0,
			isSidebar: 0,
			isNavbar: 0
		}
	},
	{
		path: 'signup',
		loadComponent: () => import('../pages/auth/register/register').then(m => m.Register),
		data: {
			isHeader: 0,
			isFooter: 0,
			isSidebar: 0,
			isNavbar: 0
		}
	},
	{
		path: 'auth/forgot-password',
		loadComponent: () => import('../pages/auth/forgot-password/forgot-password').then(m => m.ForgotPassword),
		data: {
			isHeader: 0,
			isFooter: 0,
			isSidebar: 0,
			isNavbar: 0
		}
	},
	{
		path: 'user',
		children: ownerRoutes
	},
	{
		path: 'admin',
		children: adminRoutes
	},
	{
		path: '**',
		redirectTo: 'welcome'
	},
];
